import noodleApiClient, { ApiDefinition } from '@noodleApi';

type ThisApi = ApiDefinition['/persons']['PUT'];

type Input = ThisApi['body'];
type Output = ThisApi['response'];

const findOrCreatePerson = async ({ creatorSlug, identifier, name, contactPhoneNumber, optedIntoSms }: Input): Promise<Output> => {
  const response = await noodleApiClient.put('/persons', { contactPhoneNumber, creatorSlug, identifier, name, optedIntoSms });
  return response.data;
};

export default findOrCreatePerson;
